module.exports = __webpack_public_path__ + "img/hero-sp.f2762c08.jpg";